import * as MuiBox from '@mui/material/Box'
import React from 'react'

export type BoxProps = MuiBox.BoxProps

export function Box({ children, ...props }: BoxProps) {
  return <MuiBox.default {...props}>{children}</MuiBox.default>
}
